import { useMemo } from "react";
import { useTheme } from "@mui/material/styles";
import type { Theme } from "@mui/material/styles";
import { css } from "@emotion/css";

type CssValue = Parameters<typeof css>[0];
type StylesRecord = Record<string, unknown>;
type StylesSpec = StylesRecord | ((theme: Theme) => StylesRecord);

const useCss = (stylesSpec: StylesSpec): Record<string, string> => {
  const theme = useTheme();

  return useMemo(() => {
    const normalized =
      typeof stylesSpec === "function" ? stylesSpec(theme) : stylesSpec;
    const transformed: Record<string, string> = {};

    Object.entries(normalized).forEach(([key, value = ""]) => {
      transformed[key] = css(value as CssValue);
    });

    return transformed;
  }, [stylesSpec, theme]);
};

export default useCss;
